module.exports = __webpack_public_path__ + "img/skype_ic.e747ec0c.svg";